// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import Image from 'church-theme-library/components/Image/Image'

class FeatureBlocks extends React.Component {
	render() {
		const { contentId, sectionId, data } = this.props

		if ( ! data ) {
			return null
		}

		return (
			<div className="section-feature-blocks">
				<div className="-heading">
					<h4>Heading</h4>
				</div>

				<div className="-inner">
					<div className="-block">
						<div className="-text-wrap">
							<div className="-title">
								<h2>Title</h2>
							</div>

							<div className="-text">
								<p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo.</p>
							</div>
						</div>
					</div>

					<div className="-block">
						<div className="-text-wrap">
							<div className="-title">
								<h2>Title</h2>
							</div>

							<div className="-text">
								<p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo.</p>
							</div>
						</div>
					</div>

					<div className="-block">
						<div className="-text-wrap">
							<div className="-title">
								<h2>Title</h2>
							</div>

							<div className="-text">
								<p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default FeatureBlocks
